
import { yupObject, yupTrimStringMax, yupInt, yupDate, yupFloat, yupCurrency } from '@timmons-group/shared-react-components/helpers';
import { FIELD_TYPES as FIELDS, VALIDATIONS, REGEX } from 'constants';

export const createFieldValidation = (type, label, validationMap) => {
  let validation = null;
  const required = validationMap.get(VALIDATIONS.REQUIRED);
  const maxLength = validationMap.get(VALIDATIONS.MAX_LENGTH)
  const isEmail = validationMap.get(VALIDATIONS.EMAIL)
  const isPhone = validationMap.get(VALIDATIONS.PHONE)
  const isZip = validationMap.get(VALIDATIONS.ZIP)

  switch (type) {
    case FIELDS.LONG_TEXT:
      validation = yupTrimStringMax(label, required, maxLength);
      break;
    case FIELDS.TEXT:
      validation = yupTrimStringMax(label, required, maxLength);
      // TODO: Check with BO/NG if there is a preferred way to do this - not super sustainable
      if (isEmail)
        validation = validation.email('Please enter a valid email address');
      if (isPhone)
        validation = validation.matches(REGEX.PHONE, 'Please enter a valid phone number in the format of xxx-xxx-xxxx');
      if (isZip)
        validation = validation.matches(REGEX.ZIP, 'Please enter a valid zip code in the format of xxxxx or xxxxx-xxxx');
      break;
    case FIELDS.INT:
      validation = yupInt(
        label,
        required,
        maxLength,
        'Please enter an integer'
      );
      break;
    case FIELDS.FLOAT: {
      const intD = validationMap.get(VALIDATIONS.INTEGER_DIGITS);
      const fracD = validationMap.get(VALIDATIONS.FRACTIONAL_DIGITS);
      validation = yupFloat(
        label,
        required,
        intD,
        validationMap.get(VALIDATIONS.FRACTIONAL_DIGITS),
        maxLength,
        intD
          ? `Please enter a number, with up to ${intD} digits and an optional decimal of up to ${fracD} digits`
          : `Please enter a decimal of up to ${fracD} digits`,
        validationMap.get(VALIDATIONS.MAX_VALUE),
      );
      break;
    }
    case FIELDS.CURRENCY:
      validation = yupCurrency(
        label,
        required,
        maxLength,
        'Please enter a valid dollar amount, with an optional decimal of up to two digits for cents; e.g., 1234.56'
      );
      break;

    case FIELDS.DATE:
      validation = yupDate(label, required);
      break;

    case FIELDS.CHOICE:
    case FIELDS.OBJECT: {
      // validation = (model.multiple ? yupMultiselect : yupTypeAhead)(label, required);
      validation = yupObject(label, required);
      break;
    }

    // case FIELDS.FLAG: {
    //   dynField.render.is = 'CheckBox';
    //   break;
    // }

    case FIELDS.LINK: {
      validation = yupTrimStringMax(label, required, maxLength);
      break;
    }

    // TODO: Yes clusterfield I know you are here, but I don't know what to do with you yet
    // case FIELDS.CLUSTER: {
    //   dynField.render.is = 'ClusterField';
    //   // Loop through and process fields tied to the cluster.
    //   const subFieldValidations = {};
    //   const subFields = field.layout?.map((subF) => {
    //     const { field: subField, validation: subValid } = getStructure(subF);
    //     if (subF.model) {
    //       const subName = subF.model?.name || 'unknownSub';
    //       if (subValid) {
    //         subFieldValidations[subName] = subValid;
    //       }
    //     }
    //     return subField;
    //   });
    //   dynField.render.fields = subFields;
    //   validation = array().of(object().shape(subFieldValidations).strict());
    //   break;
    // }

    default:
      break;
  }

  return validation;
}
